import { ChartDomain } from '/src/lib/types';

/**
 * Domain
 */

export type DomainProps = ChartDomain;

export class Domain implements DomainProps {
  domain: string;

  constructor(domain: string) {
    this.domain = domain;
  }
}
